// @ts-nocheck
import React from 'react';
import { Modal, Row, Col, Table, Button, Form, message } from 'antd';
import {
  DeleteIcon,
  EditIcon,
  TextField
} from '../../look';
import { PlusOutlined } from '@ant-design/icons';
import ReactMarkdown from '../../look/components/ReactMarkdown';

export const CKEditorFieldName2 = 'label';

const AnswerFormComponent = props => {
  const { choices, setChoices } = props;
  const [visible, setVisible] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [addMultiple, setAddMultiple] = React.useState(false)
  const [userResponse, setUserResponse] = React.useState({
    id: null,
    label: null,
    separator: "."
  })
  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 18 }
  };

  const addAnswer = () => {
    if (choices[0].value !== "para_question") {
      let remainingAnswers = choices?.[0]?.answerSet?.length ? [...choices[0].answerSet] : []
      if (!edit) {
        if (!addMultiple)
          remainingAnswers.push(userResponse?.label)
        else
          remainingAnswers = [
            ...remainingAnswers,
            ...userResponse?.label
              ?.split(userResponse.separator?.trim() || '.')
              ?.map(ele => ele.replaceAll("\n", "").trim())
              ?.filter(ele => ele !== "")
          ]
      } else {
        remainingAnswers[userResponse.id] = userResponse.label
      }
      setChoices([
        {
          ...choices?.[0],
          answerSet: [...remainingAnswers]
        }
      ]);
    } else {
      try {
        setChoices([
          {
            ...choices?.[0],
            answerSet: JSON.parse(userResponse.label)
          }
        ]);
      } catch (error) {
        message.error("Invalid JSON format. Please enter a valid JSON object.");
      }
    }
    setAddMultiple(false)
    form.resetFields();
    setVisible(false);
    setEdit(false);
    setUserResponse({
      id: null,
      label: null,
      separator: "."
    })
  };

  const handleEdit = record => {
    setEdit(true)
    setUserResponse({
      ...userResponse,
      id: record.idx,
      label: choices[0].value !== "para_question" ? record.value : JSON.stringify(record.value)
    })
  };

  const handleDelete = async record => {
    if (choices[0].value !== "para_question") {
      if (record.idx || record.idx === 0) {
        let prevAns = [...choices[0].answerSet]
        prevAns.splice(record.idx, 1)
        setChoices([
          {
            ...choices[0],
            answerSet: [...prevAns]
          }
        ])
      }
    } else {
      setChoices([
        {
          ...choices[0],
          answerSet: []
        }
      ])
    }
  };

  const columns = [
    {
      title: 'Label',
      key: 'label',
      render: (text, record) => (
        <ReactMarkdown>{choices[0]?.value !== "para_question" ? record.value : JSON.stringify(record.value)}</ReactMarkdown>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      render: (text, record) => (
        <>
          <EditIcon
            tooltipSuffix="Answer"
            onClick={() => {
              handleEdit(record);
              setVisible(true);
            }}
          />
          &nbsp;&nbsp;
          <DeleteIcon tooltipSuffix="Answer" onClick={() => handleDelete(record)} />
        </>
      )
    }
  ];

  const RenderTable = () => (
    <>
      <Table
        rowKey="id"
        dataSource={
          choices?.[0]?.answerSet && Object.values(choices?.[0]?.answerSet).length > 0
            ? choices?.[0]?.value !== "para_question"
              ? choices?.[0]?.answerSet.map((answer, idx) => ({ value: answer, idx }))
              : [{ idx: 0, value: choices?.[0]?.answerSet }]
            : []}
        columns={columns}
      />
    </>
  );

  return (
    <>
      <div>
        <Row>
          <Row gutter={24}>
            <Col span={6}>
              <h2>Answers</h2>
            </Col>

            <Col span={9} >
              <Button
                size="md"
                type="primary"
                ghost
                onClick={() => {
                  setVisible(true);
                  setEdit(false);
                }}
              >
                <PlusOutlined />
                Add Answer Key
              </Button>
            </Col>
            <Col span={9}>
              <Button
                size="md"
                type="primary"
                ghost
                onClick={() => {
                  setVisible(true);
                  setEdit(false);
                  setAddMultiple(true)
                }}
              >
                <PlusOutlined />
                Add Multiple Answers
              </Button>
            </Col>
          </Row>
          <br />
          <Col span={23}>
            {/* {loading && <Loading />} */}
            {choices && <RenderTable />}
          </Col>
        </Row>
        <br />

        <Modal
          footer={null}
          centered
          width="42%"
          visible={visible}
          destroyOnClose={true}
          onCancel={() => {
            setVisible(false);
            form.resetFields();
            setAddMultiple(false);
          }}
        >
          <Row>
            <Col span={23}>
              <h3>Add Answer</h3>
            </Col>
          </Row>

          <Form form={form} onFinish={addAnswer}>
            <Row justify="start">
              <Col lg={23} md={24} xs={24}>
                <div
                  className="text-area-input"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}>
                  <label>
                    Label
                  </label>
                  <textarea
                    onChange={(e) => setUserResponse({ ...userResponse, label: e.target.value })}
                    value={userResponse.label}
                    style={{ borderColor: "#9cb773", minHeight: "200px" }}
                  />
                </div>
                {addMultiple && <TextField
                  {...layout}
                  name="separator"
                  label="Separator"
                  className="separator"
                  style={{ marginTop: "20px" }}
                  placeholder="Default is full stop(.)"
                  onChange={(e) => setUserResponse({ ...userResponse, separator: e.target.value })}
                  rules={[{ required: false, message: 'Separator is required!' }]}
                />}
              </Col>
            </Row>

            <Row justify={"end"}>
              <Button type="link" htmlType="submit">
                Done
              </Button>
            </Row>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default AnswerFormComponent;
